import { render, staticRenderFns } from "./RegistrationData.html?vue&type=template&id=04df15ca&external"
import script from "./RegistrationData.vue?vue&type=script&lang=js"
export * from "./RegistrationData.vue?vue&type=script&lang=js"
import style0 from "./RegistrationData.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports